import type { Diwali2026Variant } from '~/features/promotions/utils/get-diwali-2026-variant';

import type { PromoCampaignSurfaceRenderers, RegisteredPromoCampaign } from '../types';

import { diwali2026CampaignCore } from './campaign-core';
import { diwali2026CampaignSurfaces } from './surfaces';

export { DIWALI_2026_CAMPAIGN_ID, diwali2026CampaignCore } from './campaign-core';

const diwali2026PromoCampaignTyped = {
  ...diwali2026CampaignCore,
  surfaces: diwali2026CampaignSurfaces,
} satisfies PromoCampaignSurfaceRenderers<Diwali2026Variant>;

export const diwali2026PromoCampaign = diwali2026PromoCampaignTyped as RegisteredPromoCampaign;
